import { createContext, useContext } from 'react';

/*
 * The look chosen 28.10 is «Форми 2» (his «зафиксировать этот дизайн», tag `design/v4`): everyone gets it,
 * the switcher is gone; the others stay reachable on the preview by `?look=` for comparing, until removed.
 *
 * Three looks being tried for the user to choose from (27.10, refs «glass dashboard», «widgets»,
 * «October 2023»): each is a light «glass» ground — the page in an airy gradient, the menu on a
 * frosted plate, the white panel inside it — and its own home page. On the preview a switcher at the
 * bottom flips them (and the two ages); `?look=sky|warm|fresh|glass` opens one, kept in this browser.
 * «Скло» (27.10, ref. «Aella Credit») is a layout of its own: grey frosted glass straight on the ground,
 * three columns, circles and neon chips.
 * «Скло 2» (27.10, his seven edits to «Скло» as a version of its own): a clean ground, blocks without
 * shadows, the page scrolling like any page, a profile header, blocks that come and go with the situation.
 * «Форми» (28.10, his moodboard, «совершенно новое»): warm paper, flat colour, a light grotesk (Onest),
 * plain shapes; its own font and colours across the frame too. «Форми 2» (28.10, his edits): the same with
 * soft gradients for the flat colours, few shapes, a small greeting, buttons unlike labels.
 */
export type Look = 'sky' | 'warm' | 'fresh' | 'glass' | 'glass2' | 'shapes' | 'shapes2';
export const LOOKS: ReadonlyArray<Look> = [
  'sky',
  'warm',
  'fresh',
  'glass',
  'glass2',
  'shapes',
  'shapes2',
];

/** «Форми 2» for everyone; another look only while `?look=` asks for it (kept for comparing). */
export function lookOf(): Look {
  try {
    const asked = new URLSearchParams(window.location.search).get('look');
    if (asked && (LOOKS as string[]).includes(asked)) return asked as Look;
  } catch {
    // no address to read: the chosen look
  }
  return 'shapes2';
}

const LookContext = createContext<Look>('shapes2');
export const LookProvider = LookContext.Provider;
export const useLook = () => useContext(LookContext);
